import React, {useState, useEffect} from 'react';
import {  Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import PersonalAndAccountTab from './PersonalAndAccountTab';
import BankAccountsTab from '../bankAccount/BankAccountsTab';
import WorkingTimeTab from './WorkingTimeTab';
import BusinessTab from './BusinessTab';
import AccessRightsTab from './AccessRightsTab';
import NotificationsTab from './NotificationsTab';
import DataOnDocumentsTab from './DataOnDocumentsTab';
import EmailSignatureTab from './EmailSignatureTab';
//import "./UserModal.css";
//import "bootstrap/dist/css/bootstrap.min.css";


const UserModal = (props) => {
   
    const [show, setShow] = useState(false);  
  //  const [selectedRecord, setSelectedRecord] =  useState(false);  
    const [activeTab, setActiveTab] = useState('PERSONAL_AND_ACCOUNT');
    const [t] = useTranslation();
    

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const hideModal = () => {
      setShow(false);     
      props.parentCallback(false);
    };
   
    useEffect(() => {
      setShow(props.show);
    }, [props.show])

  

    return (
 
 
      <>         
                <Modal
                  show={show}
                  onHide={hideModal}
                  container={this}
                  aria-labelledby="contained-modal-title"
                  centered
                  size="lg"                       //xl                 
                >
                    
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{t('user.label.user')}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>

                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'PERSONAL_AND_ACCOUNT'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('PERSONAL_AND_ACCOUNT')
                                                    }
                                                >
                                                    {t('user.label.personalAndAccount')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'BANK_ACCOUNT'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('BANK_ACCOUNT')
                                                    }
                                                >
                                                    {t('bankAccount.label.bankAccount')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'WORKING_TIME'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('WORKING_TIME')
                                                    }
                                                >
                                                    {t('user.label.workingTime')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'BUSINESS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('BUSINESS')
                                                    }
                                                >
                                                    {t('business.label.business')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'ACCESS_RIGHTS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('ACCESS_RIGHTS')
                                                    }
                                                >
                                                    {t('accessRights.label.accessRights')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'NOTIFICATIONS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('NOTIFICATIONS')
                                                    }
                                                >
                                                    {t('notifications.label.notifications')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'DATA_ON_DOCUMENTS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('DATA_ON_DOCUMENTS')
                                                    }
                                                >
                                                    {t('dataOnDocuments.label.dataOnDocuments')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'EMAIL_SIGNATURE'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('EMAIL_SIGNATURE')
                                                    }
                                                >
                                                    {t('emailSignature.label.emailSignature')}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <PersonalAndAccountTab
                                                isActive={activeTab === 'PERSONAL_AND_ACCOUNT'}
                                                parentCallback={hideModal}
                                                selectedRecord={props.selectedRecord}
                                            />                                           
                                            <BankAccountsTab
                                                isActive={activeTab === 'BANK_ACCOUNT'}
                                                entityId={props.selectedRecord}
                                                entityName="user"
                                            />
                                              <WorkingTimeTab
                                                isActive={activeTab === 'WORKING_TIME'}     
                                                selectedRecord={props.selectedRecord}   
                                                parentCallback={hideModal}                                     
                                             
                                            />
                                            <BusinessTab
                                                isActive={activeTab === 'BUSINESS'}
                                              
                                            />
                                            <AccessRightsTab
                                                isActive={activeTab === 'ACCESS_RIGHTS'}                                             
                                                entityId={props.selectedRecord}
                                            />
                                            <NotificationsTab
                                                isActive={activeTab === 'NOTIFICATIONS'}                                             
                                               
                                            />
                                            <DataOnDocumentsTab
                                                isActive={activeTab === 'DATA_ON_DOCUMENTS'}                                             
                                             
                                            />
                                            <EmailSignatureTab
                                                isActive={activeTab === 'EMAIL_SIGNATURE'}                                             
                                             
                                            />
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
             
                            </Modal.Body>                   
                                        
                  </Modal>   
      </>
    );
};

 
 export default UserModal;


 